export default __webpack_public_path__ + "static/media/icon-Hub-Challenges.5eaf0fd4.svg";